import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/features/LandingPage";
import JoinUsPage from "./pages/features/JoinUsPage";
import LPAboutUs from "./pages/features/LPAboutUs";
import FAQ from "./pages/features/FAQ";
import PrivacyPolicy from "./pages/features/PrivacyPolicy";
import VerifyEmailPage from "./pages/features/VerifyEmailPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/join-us" element={<JoinUsPage />} />
        <Route path="/about" element={<LPAboutUs />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/verify" element={<VerifyEmailPage />} />
      </Routes>
    </Router>
  );
}

export default App;
